var map = {
	"./channels": [
		"cbdb"
	],
	"./channels.ts": [
		"cbdb"
	],
	"./config": [
		"6a6f"
	],
	"./config.ts": [
		"6a6f"
	],
	"./old_channels": [
		"4380",
		"chunk-2d0c0aad"
	],
	"./old_channels.ts": [
		"4380",
		"chunk-2d0c0aad"
	],
	"./translation_360": [
		"c595",
		"chunk-2d216fc4"
	],
	"./translation_360.ts": [
		"c595",
		"chunk-2d216fc4"
	],
	"./translation_jc": [
		"6a4c",
		"chunk-2d0d9fd0"
	],
	"./translation_jc.ts": [
		"6a4c",
		"chunk-2d0d9fd0"
	],
	"./translation_tf15": [
		"2b04",
		"chunk-2d0bd16a"
	],
	"./translation_tf15.ts": [
		"2b04",
		"chunk-2d0bd16a"
	],
	"./translation_tf3": [
		"f599",
		"chunk-2d22cce5"
	],
	"./translation_tf3.ts": [
		"f599",
		"chunk-2d22cce5"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "807e";
module.exports = webpackAsyncContext;